// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__Sfn_M"};